const parseBoolean = (value) => {
  if (typeof value !== "string") return false;
  return ["1", "true", "yes", "on"].includes(value.toLowerCase());
};

const isProduction = process.env.NODE_ENV === "production";

const resolveBooleanFlag = (rawValue, fallbackValue) => {
  if (typeof rawValue === "string") {
    return parseBoolean(rawValue);
  }
  return fallbackValue;
};

// Default behavior: enable cart/checkout in development for implementation,
// keep both disabled by default in production unless explicitly enabled.
export const ENABLE_CART_UI = resolveBooleanFlag(
  process.env.REACT_APP_ENABLE_CART_UI,
  !isProduction,
);

export const ENABLE_CHECKOUT_UI = resolveBooleanFlag(
  process.env.REACT_APP_ENABLE_CHECKOUT_UI,
  ENABLE_CART_UI,
);
